//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function() {
    return { showScrollButton: false };
  },
  methods: {
    scrollToTopHandler: function() {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    },
    scrollHandler: function() {
      const bodyHeight = document.getElementsByTagName('body')[0].clientHeight;
      this.showScrollButton = window.scrollY > bodyHeight * 0.5;
    },
  },
  beforeMount: function() {
    window.addEventListener('scroll', this.scrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/scroll-to-top/ScrollToTop.vue